module.exports = __webpack_public_path__ + "static/media/summaryDefault.c1d3fa0f.svg";